<!-- About -->
<section id="about" class="box-white">
    <div class="wrapper padding-all">
        <!-- Section Content -->
        <div class="row margin-none">
            <div class="col-md-6 col-sm-12 padding-none padding-right-40">
                <!-- About Header -->
                <div class="section-header">
                    <h3>``सहकारी चळवळीचे यश हे सहकारी संस्थांच्या संख्यात्मक वाढीपेक्षा, सभासदांच्या नैतिकतेवर अधिक अवलंबून असते``</h3>
                </div>
                <!-- About Header End -->

                <!-- About Content -->
                <p class="justify">
                    भारताला स्वतंत्र मिळण्याच्या पुर्वीच काही समर्पित व्यक्ती एकत्र आलेत आणि त्यांनी आर्थिक मदतीसाठी एक सामान्य ध्येय घेऊन संस्थेची स्थापना केली. त्यांचा ध्येय होता की वास्तविक आर्थिक समस्येतील किंवा आर्थिक गरज असलेल्या नागपूर महानगर पालिका सेवेतील कोणत्याही
                    व्यक्तीने त्यांचे स्वप्न पुर्ण करण्यासाठी एक व्यवसायिक संस्थात्मक व्यवस्था असली पाहीजे जेणे करूण कुठल्याही सावकारांकडे प्रार्थना करायची गरज पडु नये. या सर्व म.न.पा. कर्मचा-यांचे स्वप्न दि. २१ जुलै १९३४ रोजी साकार झाले जेव्हा नागपूर
                    महानगर पालिका कर्मचारी सहकारी पत संस्था अस्तितवात आली संस्थेचे कामकाज चांगले होत असल्याने १ जुन १९८४ रोजी आर.बी.आई. ने संस्थेचे रूपांतर बँकेत करण्यासाठी परवाना जाहीर केला आणि त्यानंतर आर.बी.आई. नी १ जुन १९९५ रोजी बँकींग व्यवसाय चालु
                    ठेवण्यासाठी परवाना जाहीर केला.
                </p>
                <p class="justify">
                    या काळात बँक एका छोट्या खोलीत म.न.पा. स्थितीत जागेवर संरूवात करूण झेप घेऊन वाढली आहे बॅकेचे ४ शाखा महाल, नंदनवन, पाचपांवली, सिव्हिल लाईन ला दि. २१ फेब्रुवारी १९८६ ला आर.बी.आई. ने परवाना दिला व सर्व शाखा नफ्यात सुरू आहे. बँकेत ३१.०३.२०२१ ची स्थितीत ठेवी
                    २५४.४५ लाख आहेत तसेच अॅडव्हान्सेस रू.१३२.५६ लाख आहेत. बँकेत सर्व प्रकारचे कर्ज वाटप असुन कमी व्याजदरात सभासदांना कर्जाची सोय केली आहे. आजच्या स्थितीत बॅकेचे पुर्णत: संगणीकरण झाले आहे. बॅकेत RTGS / NEFT, डी.डी., लॉकर सुरक्षित कक्षास
                    सोयी उपलब्ध आहे, तसेच बँकेने दि.२८/०३/२०१९ पासून सर्व ठेवीदारांना व भागीदारांना ATM कार्ड ची सेवा उपलब्ध करून दिलेली आहे. </p>
                <div class="space"></div>
                <div class="button-group clearfix ">
                    <a routerLink="/about" class="btn btn-default letter-spacing">अधिक माहिती </a>
                    <a routerLink="/contact" class="btn btn-dark letter-spacing">संपर्क</a>
                </div>
                <!-- About Content End -->
            </div>
            <div class="col-md-6 col-sm-12 padding-none">
                <!-- Counter List -->
                <div class="grid-list counter-list">
                    <div class="row margin-none">
                        <!-- Grid Col -->
                        <div class="grid col-md-6 col-sm-6">
                            <a routerLink="/services/deposit">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="245" data-speed="5000" data-refresh-interval="50">
                            <img src="assets/img/p-icon-fixed-deposit.png" class="align-middle" alt="nmpksbank">
                          </span>
                                <p class="line-top text-extrabold">मुदत ठेव </p>
                            </a>
                        </div>
                        <!-- Grid Col End-->
                        <!-- Grid Col -->
                        <div class="grid col-md-6 col-sm-6">
                            <a routerLink="/services/atm">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="820" data-speed="5000" data-refresh-interval="50">
                            <img src="assets/img/p-icon-debit-card.png" class="align-middle" alt="nmpksbank">
                          </span>
                                <p class="line-top text-extrabold">ATM सुविधा </p>
                            </a>
                        </div>
                        <!-- Grid Col End-->
                        <!-- Grid Col -->
                        <div class="grid col-md-6 col-sm-6">
                            <a routerLink="/services/loan">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="98" data-speed="5000" data-refresh-interval="50">
                              <img src="assets/img/p-icon-personal-loan.png" class="align-middle" alt="nmpksbank">
                            </span>
                                <p class="line-top text-extrabold">कर्ज</p>
                            </a>

                        </div>
                        <!-- Grid Col End-->
                        <!-- Grid Col -->
                        <div class="grid col-md-6 col-sm-6">
                            <a href="javascript:void(0)" target="_black">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="32" data-speed="5000" data-refresh-interval="50">
                            <img src="assets/img/p-icon-saving-account.png" class="align-middle" alt="nmpksbank">
                          </span>
                                <p class="line-top text-extrabold">
                                    <a href="https://nmpksbank.in/assets/ac.pdf" target="_black">अकाउंट ओपनिंग</a> /
                                    <a href="https://nmpksbank.in/assets/kyc.pdf" target="_black">KYC</a>
                                </p>
                            </a>
                        </div>
                        <!-- Grid Col End-->
                    </div>
                </div>
                <app-team></app-team>

                <!-- Counter List End -->
            </div>
        </div>
        <!-- Section Content End -->
    </div>


</section>
<!-- Services -->
<section id="services">
    <!-- Section Header -->
    <div class="box-light">
        <div class="wrapper padding-all">
            <div class="section-header inline">
                <h2 class="letter-spacing line-bottom left ">संस्थेच्या शाखा</h2>
                <h5 class="letter-spacing">बँकेच्या खातेदाराकरिता सर्व शाखामधून RTGS / NEFT ची सुविधा कोटक महिंद्रा बँकेमार्फत उपलब्ध करून देण्यात आली असून IFSC कोड आणि बँकेच्या शाखा खालील नमूद प्रमाणे आहेत.</h5>
                <!-- <a href="#" class="btn btn-default v-center">REQUEST A QUOTE</a> -->
            </div>
        </div>
    </div>
    <!-- Section Header End -->

    <!-- Section Content -->
    <div class="box-grey">
        <div class="wrapper">
            <div class="row margin-none col-half">
                <div class="col-md-4 col-sm-12 half padding-all">
                    <!-- <p><img src="assets/img/works-1-big.png" alt="Services" class="img-full"></p> -->
                    <h1 class="title-big letter-spacing line-bottom left">SMS सुविधा</h1>
                    <p>बँकेचे खातेदार / सभासदांसाठी S. M. S. सेवा सुरु करण्यात आली असून, बँकेत आपला मोबाईल क्रमांक नमूद करून सेवेचा लाभ घ्यावा. बँकेतर्फे डेबिट कार्ड सेवा (ATM ) सुरु कारणात आलेली आहे. बँकेचे कुठल्याही शाखेतून व्यवहार करण्याची सुविधा सुरु
                        करण्यात आलेली आहे.</p>
                    <div class="space "></div>
                    <p><a routerLink="/contact " class="btn btn-dark letter-spacing ">संपर्क</a></p>
                </div>
                <div class="col-md-8 col-sm-12 half padding-all box-white ">
                    <app-branch-address></app-branch-address>
                </div>
            </div>
        </div>
    </div>
    <!-- Section Content End -->
</section>
<!-- Services End -->